import React from "react";
import { Container, Carousel } from "react-bootstrap";
import { FaStar } from "react-icons/fa";

const testimonialsData = [
    {
        name: "Ramesh Patel",
        location: "Madhya Pradesh",
        image: "images/img/farmer-1.jpg",
        rating: 5,
        text: "After using Hindustan Agro Life products, I noticed significant improvement in crop growth and soil quality. The yield increased consistently, and the products proved to be safe and reliable for long-term farming."
    },
    {
        name: "Suresh Yadav",
        location: "Maharashtra",
        image: "images/img/farmer-2.jpg",
        rating: 5,
        text: "As a distribution partner, I appreciate the company’s farmer-focused approach and consistent product quality. The results are visible in the field, and the technical support and guidance make it easy to build long-term trust with farmers."
    },
    {
        name: "Mahendra Singh",
        location: "Rajasthan",
        image: "images/img/farmer-3.jpg",
        rating: 5,
        text: "Hindustan Agro Life’s solutions help maintain soil health while improving overall crop quality. Reduced chemical dependency and sustainable results make these products ideal for modern and responsible agriculture."
    }
];

const Testimonials = () => {
    return (
        <section className="section testimonial-section">
            <Container>

                {/* CENTERED HEADING */}
                <div className="section-title fade-up text-center">
                    <h2>Farmer Testimonials</h2>
                    <p>
                        Real experiences from farmers who trust Hindustan Agro Life
                        for sustainable and reliable crop solutions.
                    </p>
                </div>

                <Carousel indicators={false}>
                    {testimonialsData.map((item, index) => (
                        <Carousel.Item key={index}>
                            <div className="testimonial-card fade-up">

                                {/* Farmer Image */}
                                <div className="testimonial-img">
                                    <img src={item.image} alt={item.name} />
                                </div>

                                {/* Stars */}
                                <div className="testimonial-stars">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar
                                            key={i}
                                            className={i < item.rating ? "star active" : "star"}
                                        />
                                    ))}
                                </div>

                                {/* Text */}
                                <p className="testimonial-text">“{item.text}”</p>

                                {/* Name */}
                                <h5>{item.name}</h5>
                                <span>{item.location}</span>

                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>

            </Container>
        </section>
    );
};

export default Testimonials;
